import React from 'react';
import FacetItemWrapper from './facetItemWrapper';

const FacetItem = props => (
  <FacetItemWrapper {...props}>
    <span className="facet__checkbox" />
  </FacetItemWrapper>
);

export default FacetItem;
